var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommitmentPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.61523,
    width: 18,
    height: 18,
    rx: 3,
    stroke: "#7663EB",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#7663EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#7663EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#7663EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 9,
    r: 1,
    fill: "#7663EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 13,
    r: 1,
    fill: "#7663EB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 1,
    fill: "#7663EB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 1,
    fill: "#7663EB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 1,
    fill: "#7663EB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1,
    fill: "#7663EB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 9,
    r: 1,
    fill: "#7663EB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 13,
    r: 1,
    fill: "#7663EB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1,
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitmentPrimary);
export default __webpack_public_path__ + "static/media/commitment-primary.948f94fbf26af1b0d5e8790169267250.svg";
export { ForwardRef as ReactComponent };